module.exports = __webpack_public_path__ + "static/img/banner-bg.fa3c23ab.png";